import { TASK_STATUSES } from 'advanced-filters/data/taskOptions';

export const listTaskTemplates = `
query {
  taskTemplates {
    value: id
    label: name
    taskType
  }
}
`;

export const getTaskOptionsBasedOnEntityType = (entity: any) => {
  if (entity.key === 'status') {
    return TASK_STATUSES;
  }
  return [];
};
